// client/src/data/facultyCabinData.js

// Manually cleaned and formatted data based on your input
export const facultyCabinData = [
  { name: "Abhinav & Muthu Singh", cabin: "C-518 (AB01)" },
  { name: "Abhishek Raj", cabin: "B-514 (AB01)" },
  { name: "Abhishek Shrivastava", cabin: "A-229 (AB01)" },
  { name: "Ajay Kumar Bhurjee", cabin: "A-301 (AB01)" },
  { name: "Akshara Makrariya", cabin: "A-302 (AB01)" },
  { name: "Amit Kumar Singh", cabin: "C-502 (AB01)" },
  { name: "Anil Kumar", cabin: "A-237 (AB01)" },
  { name: "Anita Yadav", cabin: "A-315 (AB01)" },
  { name: "Ankit Pal", cabin: "A-502 (AB01)" },
  { name: "Ashok Kumar Baral", cabin: "C-531 (AB01)" },
  { name: "Atul & Vaisali Vike", cabin: "A-511 (AB01)" },
  { name: "Avirup Das", cabin: "A-313 (AB01)" },
  { name: "Badla Pawan Babu", cabin: "B-410 (AB01)" },
  { name: "Balaguru S", cabin: "A-210 (AB01)" },
  { name: "Chandrama Swain", cabin: "B-310 (AB01)" },
  { name: "Chour Singh Rajput", cabin: "A-503 (AB01)" },
  { name: "Deep Chandra Upadhyay", cabin: "C-524 (AB01)" },
  { name: "Devendra Kumar & Ashutosh Singh", cabin: "C-539 (AB01)" },
  { name: "Dipankar Sutradhar", cabin: "A-507 (AB01)" },
  { name: "Dipti Bhojwari & Vikas", cabin: "C-507 (AB01)" },
  { name: "Dr. A Balaji", cabin: "A-241 (AB01)" },
  { name: "Dr. A V R Mayuri", cabin: "S-209 (AB02)" },
  { name: "Dr. A. Baseera", cabin: "FC306 (AB02)" }, // Also A-103 (AB01)
  { name: "Dr. Aanjan Kumar", cabin: "FC322 (AB02)" }, // Also A-224 (AB01)
  { name: "Dr. Abdul Rahman", cabin: "F-113 (AB02)" },
  { name: "Dr. Abdul Rashid", cabin: "A-406 (AB01)" },
  { name: "Dr. Abha Sharma", cabin: "G-17 (AB02)" },
  { name: "Dr. Abha Trivedi", cabin: "S-205 (AB02)" },
  { name: "Dr. Abhay Vidyarthi", cabin: "G-27 (AB015-005) (AB01)" },
  { name: "Dr. Abhinav", cabin: "B-404 (AB01)" },
  { name: "Dr. Abhinav Kumar", cabin: "A-408 (AB01)" },
  { name: "Dr. Abhishek", cabin: "B-405 (AB01)" },
  { name: "Dr. Abhishek Kumar", cabin: "G-11 (AB02)" }, // Also A-121 (AB01)
  { name: "Dr. Abhishek Kumar Shukla", cabin: "A-116 (AB01)" },
  { name: "Dr. Adarsh Patel", cabin: "F-121 (AB02)" },
  { name: "Dr. Adnan Abbasi", cabin: "A-107 (AB01)" },
  { name: "Dr. Ajay Kumar Phulre", cabin: "S-211 (AB02)" },
  { name: "Dr. Ajay Sharma", cabin: "A-120 (AB01)" }, // Also FC413 (AB02)
  { name: "Dr. Ajeet Singh", cabin: "B-315 (AB01)" }, // Also FC404 (AB02)
  { name: "Dr. Ambey Verma", cabin: "A-410 (AB01)" },
  { name: "Dr. Amit Kumar", cabin: "C-526 (AB01)" },
  { name: "Dr. Amrita Parashar", cabin: "F-110 (AB02)" },
  { name: "Dr. Anand Motwani", cabin: "B-407 (AB01)" },
  { name: "Dr. Anantha Kumaran", cabin: "G-07 (AB01)" },
  { name: "Dr. Anil Kumar Yadav", cabin: "F-120 (AB02)" },
  { name: "Dr. Anirban Bhowmick", cabin: "N/A" },
  { name: "Dr. Anjali Mathur", cabin: "A-319 (AB01)" }, // Also FC424 (AB02)
  { name: "Dr. Anju", cabin: "G-02 (AB02)" },
  { name: "Dr. Ankur Beohar", cabin: "A-244 (AB01)" },
  { name: "Dr. Ankur Jain", cabin: "S-219 (AB02)" },
  { name: "Dr. Ankush Tharkar", cabin: "B-411 (AB01)" },
  { name: "Dr. Antima Jain", cabin: "A-225 (AB01)" }, // Also FC324 (AB02)
  { name: "Dr. Anupam Sen", cabin: "C-522 (AB01)" },
  { name: "Dr. Anvesh Nella", cabin: "A-322 (AB01)" },
  { name: "Dr. Arindam Dutta", cabin: "C-509 (AB01)" },
  { name: "Dr. Arindam Ghosh", cabin: "A-506 (AB01)" },
  { name: "Dr. Arindam Sadhukhan", cabin: "A-119 (AB01)" },
  { name: "Dr. Arun Kumar K.", cabin: "A-108 (AB01)" },
  { name: "Dr. Arup Torai", cabin: "B-414 (AB01)" },
  { name: "Dr. Ashfaq Ahmad Najar", cabin: "FC305 (AB02)" },
  { name: "Dr. Ashish Kumar Kesarwany", cabin: "A-314 (AB01)" },
  { name: "Dr. Ashok Kumar Patel", cabin: "G-03 (AB01)" },
  { name: "Dr. Ava Sharma", cabin: "G-21 (AB01)" },
  { name: "Dr. Bandla Pavan Babu", cabin: "FC314 (AB02)" }, // Likely same as Badla Pawan Babu B-410 (AB01)
  { name: "Dr. BASEERA A", cabin: "A-103 (AB01)" }, // Likely same as Dr. A. Baseera FC306 (AB02)
  { name: "Dr. Benevatho Jaison A", cabin: "A-401 (AB01)" },
  { name: "Dr. Bhakti Parashar", cabin: "A-304 (AB01)" },
  { name: "Dr. Bhumika Choksi", cabin: "A-318 (AB01)" },
  { name: "Dr. Bhupendra Panchal", cabin: "FC415 (AB02)" },
  { name: "Dr. Bhuvenshwari", cabin: "G-18 (AB01)" },
  { name: "Dr. C. P. Koushik", cabin: "G-08 (AB02)" },
  { name: "Dr. Chandan Behera", cabin: "B-314 (AB01)" }, // Likely same as Dr. Chandan Kumar Behera S-215 (AB02)
  { name: "Dr. Chandan Kumar Behera", cabin: "S-215 (AB02)" },
  { name: "Dr. Chour Singh Rajpoot", cabin: "FC402 (AB02)" }, // Likely same as Chour Singh Rajput A-503 (AB01)
  { name: "Dr. D. Saravanan", cabin: "F-112 (AB02)" },
  { name: "Dr. Daood Saleem", cabin: "C-513 (AB01)" }, // Also FC307 (AB02)
  { name: "Dr. Debashis Adhikari", cabin: "019 (AB01)" }, // Assuming G-19 or similar
  { name: "Dr. Dev brat Gupta", cabin: "G-10 (AB01)" },
  { name: "Dr. Devraj Vishnu", cabin: "F-108 (AB02)" },
  { name: "Dr. Dheeresh Soni", cabin: "A-217 (AB01)" }, // Also FC418 (AB02)
  { name: "Dr. Dilip Kumar", cabin: "G-20 (AB01)" },
  { name: "Dr. Dip Mukherjee", cabin: "A-211 (AB01)" },
  { name: "Dr. Dipanjana Hazra", cabin: "A-524 (AB01)" },
  { name: "Dr. E. Nirmala", cabin: "F-104 (AB02)" }, // Also B-412 (AB01)
  { name: "Dr. Enagandula Prasad", cabin: "A-416 (AB01)" },
  { name: "Dr. Feroz Babu", cabin: "B-505 (AB01)" },
  { name: "Dr. G. R. Hemalakshmi", cabin: "S-221 (AB02)" }, // Also G-14 (AB01)
  { name: "Dr. Ganeshan G.", cabin: "A-415 (AB01)" },
  { name: "Dr. Gaurav Soni", cabin: "C-404 (AB01)" }, // Also FC301 (AB02)
  { name: "Dr. Geetanjali Giri", cabin: "B-309 (AB01)" },
  { name: "Dr. GK", cabin: "A-250 (AB01)" },
  { name: "Dr. Gobinda Ghosh", cabin: "A-421 (AB01)" },
  { name: "Dr. Gopal S Tandel", cabin: "A-218 (AB01)" },
  { name: "Dr. Gunjan Ansari", cabin: "FC417 (AB02)" }, // Also 2nd Floor Ext. Cabin (AB01)
  { name: "Dr. Hariharan R", cabin: "S-207 (AB02)" },
  { name: "Dr. Hariharasitaraman. S", cabin: "N/A" },
  { name: "Dr. Harish Babu", cabin: "G-22 (AB01)" },
  { name: "Dr. Harshlata Vishwakarma", cabin: "F-105 (AB02)" },
  { name: "Dr. Hemant Kumar Nashine", cabin: "A-109 (AB01)" },
  { name: "Dr. Hemraj S.L.", cabin: "F-107 (AB02)" },
  { name: "Dr. Humaira Fatima", cabin: "A-509 (AB01)" },
  { name: "Dr. Indhumathi", cabin: "A-311 (AB01)" },
  { name: "Dr. Irfan Alam", cabin: "S-202 (AB02)" },
  { name: "Dr. J MANIKANDAN", cabin: "N/A" },
  { name: "Dr. J.P. Shritharanyaa", cabin: "G-17 (AB01)" },
  { name: "Dr. Jagriti Gupta", cabin: "B-409 (AB01)" },
  { name: "Dr. Jalaluddin Khan", cabin: "S-218 (AB02)" },
  { name: "Dr. Jasmine Selvakumari", cabin: "G-05 (AB01)" },
  { name: "Dr. Jastin Samual", cabin: "A-205 (AB01)" },
  { name: "Dr. Jitendra Pratap Singh Mathur", cabin: "FC311 (AB02)" }, // Also A-413 (AB01)
  { name: "Dr. Juhi Yasmeen", cabin: "A-238 (AB01)" },
  { name: "Dr. Jyothi Chouhan", cabin: "G-14 (AB02)" },
  { name: "Dr. K. Murugeswari", cabin: "A-403 (AB01)" }, // Also FC408 (AB02)
  { name: "Dr. Kamlesh Chandravanshi", cabin: "FC403 (AB02)" }, // Also AB-410 (AB01)
  { name: "Dr. Kannaiya Raja N", cabin: "A-240 (AB01)" }, // Likely same as Dr. N. Kanniya Raja FC423 (AB02)
  { name: "Dr. Komarasamy G", cabin: "G-03 (AB02)" },
  { name: "Dr. KR. SIVABALAN", cabin: "C-532 (AB01)" }, // Likely same as Dr. Sivabalan KR FC320 (AB02)
  { name: "Dr. Krishna Chouhan", cabin: "G-31 (AB015-009) (AB01)" },
  { name: "Dr. Kumkum Dubey", cabin: "A-501 (AB01)" }, // Likely same as Mrs. Kumkum Dueby A-414 (AB01)
  { name: "Dr. Lakshmi D.", cabin: "F-122 (AB02)" },
  { name: "Dr. Lokesh Malviya", cabin: "FC313 (AB02)" },
  { name: "Dr. M K Jayanthi Kannan", cabin: "F-115 (AB02)" },
  { name: "Dr. M Manimaran", cabin: "G-09 (AB02)" },
  { name: "Dr. M Suresh", cabin: "G-28 (AB015-006) (AB01)" }, // Likely same as Mr. M. Suresh S-201 (AB02)
  { name: "Dr. M. Maragatharajan", cabin: "A-212 (AB01)" }, // Also FC303 (AB02)
  { name: "Dr. Mahendran", cabin: "AB-210 (AB01)" },
  { name: "Dr. Mamta Agarwal", cabin: "A-201 (AB01)" },
  { name: "Dr. Manisha Jain", cabin: "G-04 (AB01)" },
  { name: "Dr. Manisha Singh", cabin: "G-33 (AB015-011) (AB01)" },
  { name: "Dr. Manoj Acharya", cabin: "A-204 (AB01)" },
  { name: "Dr. Manoj Kumar", cabin: "F-118 (AB02)" },
  { name: "Dr. Manorma Chouhan", cabin: "F-102 (AB02)" }, // Likely same as Ms. Manorama Chouhan A-118 (AB01)
  { name: "Dr. Mayank Sharma", cabin: "A-113 (AB01)" },
  { name: "Dr. Md. Zeeshan", cabin: "A-112 (AB01)" },
  { name: "Dr. Mohammad Ishrat", cabin: "FC319 (AB02)" },
  { name: "Dr. Mohammad Sultan Alam", cabin: "FC321 (AB02)" }, // Likely same as Dr. Sultan Alam C-504 (AB01)
  { name: "Dr. Mohd Rafi Lone", cabin: "S-222 (AB02)" },
  { name: "Dr. Monalisha", cabin: "B-403 (AB01)" },
  { name: "Dr. Monica", cabin: "FC405 (AB02)" }, // Likely same as Dr. P. Monica A-519 (AB01)
  { name: "Dr. Mostaid Ahmed", cabin: "A-504 (AB01)" },
  { name: "Dr. Muneeswaran V", cabin: "S-204 (AB02)" },
  { name: "Dr. Munsifa Firdaus Khan", cabin: "A-515 (AB01)" }, // Also FC412 (AB02)
  { name: "Dr. N. B. Prakash", cabin: "S-214 (AB02)" },
  { name: "Dr. N. Kanniya Raja", cabin: "FC423 (AB02)" }, // Likely same as Dr. Kannaiya Raja N A-240 (AB01)
  { name: "Dr. Narottam Das Patel", cabin: "F-117 (AB02)" },
  { name: "Dr. Navneet Kumar Verma", cabin: "A-203 (AB01)" },
  { name: "Dr. Neeraj Sharma", cabin: "A-122 (AB01)" }, // Also 1st Floor Ext. Cabin
  { name: "Dr. Neha Choubey", cabin: "Admission office" },
  { name: "Dr. Nilamadhab Mishra", cabin: "F-119 (AB02)" },
  { name: "Dr. Nilesh Kunhare", cabin: "C-401 (AB01)" }, // Also FC310 (AB02)
  { name: "Dr. Om Prakash Pahari", cabin: "A-316 (AB01)" },
  { name: "Dr. P. Monica", cabin: "A-519 (AB01)" }, // Likely same as Dr. Monica FC405 (AB02)
  { name: "Dr. Pallabi Sarkar", cabin: "A-310 (AB01)" },
  { name: "Dr. Pallav", cabin: "A-215 (AB01)" },
  { name: "Dr. Pankaj Kumar", cabin: "A-417 (AB01)" },
  { name: "Dr. Paras Jain", cabin: "G-22 (AB02)" },
  { name: "Dr. Pavan Kumar", cabin: "A-110 (AB01)" },
  { name: "Dr. Pavithra Rathinavel", cabin: "B-415 (AB01)" },
  { name: "Dr. Pijush Kanti Mondal", cabin: "A-214 (AB01)" },
  { name: "Dr. Pon Harshavardhanan", cabin: "G-12 (AB02)" },
  { name: "Dr. Pooja", cabin: "A-312 (AB01)" },
  { name: "Dr. Poonkuntran S", cabin: "N/A" }, // Also FC312 (AB02)
  { name: "Dr. Pradeep Kashyap", cabin: "A-325 (AB01)" },
  { name: "Dr. Pradeep Kumar Mishra", cabin: "G-21 (AB02)" },
  { name: "Dr. Pratosh Kumar Pal", cabin: "G-19 (AB02)" },
  { name: "Dr. Praveen Kumar Tyagi", cabin: "FC414 (AB02)" }, // Likely same as Mr. Praveen Kumar Tyagi A-317 (AB01)
  { name: "Dr. Praveen Lalwani", cabin: "G-15 (AB02)" },
  { name: "Dr. Preetam Suman", cabin: "FC421 (AB02)" }, // Also A-208 (AB01)
  { name: "Dr. Priscilla Dinkar Morya", cabin: "S-224 (AB02)" },
  { name: "Dr. Priya Mumaran", cabin: "A-418 (AB01)" },
  { name: "Dr. Priyanka Ray", cabin: "A-114 (AB01)" },
  { name: "Dr. PUSHINDER SINGH PATHEJA", cabin: "G-09 (AB01)" }, // Likely same as Dr. Pushpinder Singh Patheja F-101 (AB02)
  { name: "Dr. Pushpinder Singh Patheja", cabin: "F-101 (AB02)" },
  { name: "Dr. R. Senthil Kumar", cabin: "G-11 (AB01)" },
  { name: "Dr. R. Sukumar", cabin: "S-210 (AB02)" },
  { name: "Dr. Raghavendra Mishra", cabin: "G-06 (AB02)" },
  { name: "Dr. Rahul Shrivastava", cabin: "5th Floor Ext. Cabin (AB01)" },
  { name: "Dr. Rajdeep Singh Payal", cabin: "A-321 (AB01)" },
  { name: "Dr. Rajeev", cabin: "A-248 (AB01)" },
  { name: "Dr. Rajit Nair", cabin: "F-123 (AB02)" },
  { name: "Dr. Rajneesh Kumar Patel", cabin: "FC407 (AB02)" }, // Likely same as Rajneesh Kumar Patel A-306 (AB01)
  { name: "Dr. Rakesh Shrivastava", cabin: "S-213 (AB02)" },
  { name: "Dr. Ram Kumar", cabin: "F-114 (AB02)" }, // Also C-501 (AB01)
  { name: "Dr. Ramraj Dangi", cabin: "A-424 (AB01)" }, // Also FC401 (AB02)
  { name: "Dr. Ramu Pashupathi Suganeshwar", cabin: "A-308 (AB01)" },
  { name: "Dr. Ranjitha Kumar", cabin: "B-402 (AB01)" },
  { name: "Dr. Ravi Verma", cabin: "A-514 (AB01)" }, // Also FC309 (AB02)
  { name: "Dr. Reena Jain", cabin: "A-104 (AB01)" },
  { name: "Dr. Rizwan Ur Rahman", cabin: "S-220 (AB02)" },
  { name: "Dr. Rudra Kalyan Nayak", cabin: "S-208 (AB02)" },
  { name: "Dr. Rupesh Kumari", cabin: "A-111 (AB01)" },
  { name: "Dr. S Devaraju", cabin: "F-116 (AB02)" },
  { name: "Dr. S. AANJANKUMAR", cabin: "A-224 (AB01)" }, // Likely same as Dr. Aanjan Kumar FC322 (AB02)
  { name: "Dr. S. K. Das", cabin: "B-508 (AB01)" },
  { name: "Dr. S. Kannan", cabin: "G-01 (AB01)" },
  { name: "Dr. S. Periyanayagi", cabin: "G-13 (AB02)" },
  { name: "Dr. S. Poonkuntran", cabin: "FC312 (AB02)" }, // Likely same as Dr. Poonkuntran S N/A
  { name: "Dr. Sajjad Ahmed", cabin: "G-10 (AB02)" },
  { name: "Dr. Sanat Jain", cabin: "C-535 (AB01)" }, // Also F-109 (AB02) / C-514 (AB01)
  { name: "Dr. Sanay Naha", cabin: "A-249 (AB01)" },
  { name: "Dr. Sandeep Monga", cabin: "G-13 (AB01)" },
  { name: "Dr. Sandip Mal", cabin: "A-207 (AB01)" }, // Also FC422 (AB02)
  { name: "Dr. Sanjib Nayak", cabin: "A-517 (AB01)" },
  { name: "Dr. Santhosh Kumar Sahoo", cabin: "F-103 (AB02)" },
  { name: "Dr. Santosh Bal", cabin: "B-301 (AB01)" },
  { name: "Dr. Santosh Kumar Bhal", cabin: "A-512 (AB01)" },
  { name: "Dr. Santosh Sahu", cabin: "4th Floor Ext. Cabin" },
  { name: "Dr. Saravanan S", cabin: "G-07 (AB02)" },
  { name: "Dr. Sasmita Padhy", cabin: "A-206 (AB01)" }, // Also FC420 (AB02)
  { name: "Dr. Saurabh Kumar Maurya", cabin: "A-520 (AB01)" },
  { name: "Dr. Saurabh Mishra", cabin: "B-313 (AB01)" },
  { name: "Dr. Senthilkumar", cabin: "G-01 (AB02)" },
  { name: "Dr. Shafiul Alom Ahmed", cabin: "A-117 (AB01) / B-513 (AB01)" },
  { name: "Dr. Shagun Sharma", cabin: "S-216 (AB02)" },
  { name: "Dr. Shahab Saquib Sohail", cabin: "C-515 (AB01)" }, // Also FC317 (AB02)
  { name: "Dr. Shahana Gajala Qureshi", cabin: "G-20 (AB02)" },
  { name: "Dr. Sharat Chandra Tripati", cabin: "G-15 (AB01)" },
  { name: "Dr. Sharmila", cabin: "A-402 (AB01)" }, // Likely same as Dr. Sharmila Joseph FC416 (AB02)
  { name: "Dr. Sharmila Joseph", cabin: "FC416 (AB02)" },
  { name: "Dr. Sheetal Sharma", cabin: "A-102 (AB01)" },
  { name: "Dr. Shiv Shankar Prasad", cabin: "S-217 (AB02)" },
  { name: "Dr. Shriram R", cabin: "N/A" },
  { name: "Dr. Shweta Saxena", cabin: "S-206 (AB02)" },
  { name: "Dr. Shweta Singh", cabin: "A-518 (AB01)" },
  { name: "Dr. Shwetha Mukarjee", cabin: "N/A" },
  { name: "Dr. Sibananda Mohanty", cabin: "B-507 (AB01)" },
  { name: "Dr. Siddartha Maiti", cabin: "A-245 (AB01)" },
  { name: "Dr. Siddharth Singh Chouhan", cabin: "FC316 (AB02)" }, // Likely same as Dr. Sidharth Singh Chauhan A-242 (AB01)
  { name: "Dr. Sidharth Singh Chauhan", cabin: "A-242 (AB01)" },
  { name: "Dr. Siradujun", cabin: "G-30 (AB015-008) (AB01)" },
  { name: "Dr. Sivabalan KR", cabin: "FC320 (AB02)" }, // Likely same as Dr. KR. SIVABALAN C-532 (AB01)
  { name: "Dr. Sivasankaran", cabin: "A-243 (AB01)" },
  { name: "Dr. Soma Saha", cabin: "AB-406 (AB01)" },
  { name: "Dr. Sonjoy Pan", cabin: "B-305 (AB01)" },
  { name: "Dr. Soumitra Keshari Nayak", cabin: "A-246 (AB01)" },
  { name: "Dr. Sripriyan", cabin: "A-115 (AB01)" },
  { name: "Dr. Subash Chandra Bose", cabin: "G-04 (AB02)" },
  { name: "Dr. Subash Chandra Patel", cabin: "G-16 (AB02)" }, // Likely same as Dr. Subhash Chandra Patel A-404 (AB01)
  { name: "Dr. Subhash Chandra Patel", cabin: "A-404 (AB01)" },
  { name: "Dr. Subrata Nath", cabin: "A-508 (AB01)" },
  { name: "Dr. Sultan Alam", cabin: "C-504 (AB01)" }, // Likely same as Dr. Mohammad Sultan Alam FC321 (AB02)
  { name: "Dr. Sumit Som", cabin: "A-426 (AB01)" }, // Also 4th Floor Ext. Cabin
  { name: "Dr. Suneet Joshi", cabin: "B-512 (AB01)" }, // Also FC308 (AB02)
  { name: "Dr. Tanya Nishad, Disha Kumari", cabin: "A-513 (AB01)" },
  { name: "Dr. Thamim", cabin: "B-408 (AB01)" },
  { name: "Dr. Trapti Sharma", cabin: "F-124 (AB02)" },
  { name: "Dr. Velmurugan L", cabin: "F-111 (AB02)" }, // Also G-24 (AB015-002) (AB01)
  { name: "Dr. Venkat Prasad Padhy", cabin: "G-24 (AB02)" },
  { name: "Dr. Venkateswara Rao", cabin: "FC302 (AB02)" },
  { name: "Dr. Vijay Birchha", cabin: "S-203 (AB02)" },
  { name: "Dr. Vijay Kumar Patidar", cabin: "A-226 (AB01)" },
  { name: "Dr. Vijay Kumar Trivedi", cabin: "FC409 (AB02)" },
  { name: "Dr. Vijendra Singh Bramhe", cabin: "FC410 (AB02)" }, // Likely same as Vijendra Singh Bramhe C-505 (AB01)
  { name: "Dr. Vikas Panthi", cabin: "FC419 (AB02)" }, // Also A-324 (AB01)
  { name: "Dr. Vinesh Kumar", cabin: "G-05 (AB02)" },
  { name: "Dr. Vinod Bhatt", cabin: "G-02 (AB01)" },
  { name: "Dr. Vinod Kumar Jata", cabin: "C-510 (AB01)" },
  { name: "Dr. Vipin Jain", cabin: "FC318 (AB02)" }, // Likely same as Mr. Vipin Jain B-510 (AB01)
  { name: "Dr. Vipin Mishra", cabin: "A-409 (AB01)" },
  { name: "Dr. Virenar Kushwaha", cabin: "A-309 (AB01)" }, // Likely same as Dr. Virendra Singh Kushwah S-212 (AB02)
  { name: "Dr. Virendra Singh Kushwah", cabin: "S-212 (AB02)" },
  { name: "Dr. Vivek Parashar", cabin: "A-239 (AB01)" },
  { name: "Dr. Vivek Sharma", cabin: "A-219 (AB01)" },
  { name: "Dr. Xavier", cabin: "B-312 (AB01)" },
  { name: "Dr. Yogesh Shukla", cabin: "Admission office" },
  { name: "Dr. Zaheer Kareem Ansari", cabin: "G-12 (AB01)" },
  { name: "Dr. Zavad Khan", cabin: "G-16 (AB01)" },
  { name: "E. NIRMALA", cabin: "B-412 (AB01)" }, // Likely same as Dr. E. Nirmala F-104 (AB02)
  { name: "Evangeline Christina", cabin: "A-227 (AB01)" },
  { name: "Harish Chandra", cabin: "A-216 (AB01)" },
  { name: "Hemanta Kalita", cabin: "A-522 (AB01)" },
  { name: "Imroz Khan & Azimal Husan", cabin: "C-520 (AB01)" }, // Likely same as Mr. Imroz Khan G-18 (AB02)
  { name: "IPR & WEC", cabin: "AB-306 (AB01)" },
  { name: "Jay Prakash Maurya", cabin: "FC304 (AB02)" }, // Likely same as MR. JAY PRAKASH MAURYA A-221 (AB01)
  { name: "Jitendra Pratap Singh Mathur", cabin: "A-413 (AB01)" }, // Likely same as Dr. Jitendra Pratap Singh Mathur FC311 (AB02)
  { name: "Jyoti Badge", cabin: "B-504 (AB01)" },
  { name: "Kajal Agarwal & Tanya Srivastava", cabin: "C-511 (AB01)" },
  { name: "Kiran Kumar Behera", cabin: "A-523 (AB01)" },
  { name: "Kumar Pandey", cabin: "A-303 (AB01)" },
  { name: "M.R. Thiyagu Priyadharsan", cabin: "AB-510 (AB01)" },
  { name: "Mayank Gupta", cabin: "Admission Office" },
  { name: "Md. Tauseef Qamar", cabin: "B-413 (AB01)" },
  { name: "Mohd Tangeel & Chaitanya", cabin: "C-512 (AB01)" },
  { name: "Mr. Abdur Raoof Khan", cabin: "A-223 (AB01)" },
  { name: "Mr. ANIL MEWADA (Secy. of Registrar)", cabin: "N/A" },
  { name: "Mr. Ashfaq Ahmed", cabin: "B-406 (AB01)" },
  { name: "Mr. Deepak Kimar", cabin: "A-419 (AB01)" },
  { name: "Mr. G. Ganesan", cabin: "FC406 (AB02)" },
  { name: "Mr. Imroz Khan", cabin: "G-18 (AB02)" }, // Likely same as Imroz Khan & Azimal Husan C-520 (AB01)
  { name: "Mr. Javed Khan Sheikh", cabin: "FC315 (AB02)" },
  { name: "MR. JAY PRAKASH MAURYA", cabin: "A-221 (AB01)" }, // Likely same as Jay Prakash Maurya FC304 (AB02)
  { name: "Mr. K.K. Nair", cabin: "A-B019 (AB01)" },
  { name: "Mr. M. Suresh", cabin: "S-201 (AB02)" }, // Likely same as Dr. M Suresh G-28 (AB015-006) (AB01)
  { name: "Mr. Manikandan S.P", cabin: "A-407 (AB01)" },
  { name: "Mr. Mohd Amir", cabin: "AB-506 (AB01)" },
  { name: "Mr. Praveen Kumar Tyagi", cabin: "A-317 (AB01)" }, // Likely same as Dr. Praveen Kumar Tyagi FC414 (AB02)
  { name: "Mr. RAVI KUMAR SINGH", cabin: "AB-310 (AB01)" },
  { name: "Mr. Sanat Jain", cabin: "F-109 (AB02)" }, // Also C-514 (AB01) / Dr. Sanat Jain C-535 (AB01)
  { name: "Mr. Sathyabrata Nath", cabin: "FC411 (AB02)" },
  { name: "Mr. Vipin Jain", cabin: "B-510 (AB01)" }, // Likely same as Dr. Vipin Jain FC318 (AB02)
  { name: "Mr. Vishal Singh Bhati", cabin: "C-528 (AB01)" },
  { name: "Mrs. Adeeba Bilquees", cabin: "AB-406 (AB01)" },
  { name: "Mrs. Garima Jain", cabin: "F-106 (AB02)" },
  { name: "Mrs. Kumkum Dueby", cabin: "A-414 (AB01)" }, // Likely same as Dr. Kumkum Dubey A-501 (AB01)
  { name: "Ms. Adyasha Sahu", cabin: "S-223 (AB02)" },
  { name: "Ms. Deeksha Singh", cabin: "C-402 (AB01)" },
  { name: "Ms. Geeta Singh", cabin: "G-23 (AB02)" },
  { name: "Ms. J. Jayanthi", cabin: "FC323 (AB02)" },
  { name: "Ms. Kalyani Wankehde", cabin: "A-422 (AB01)" },
  { name: "Ms. Komal", cabin: "A-101 (AB01)" },
  { name: "Ms. ManJari Upamanyu", cabin: "AB-511 (AB01)" },
  { name: "Ms. Manorama Chouhan", cabin: "A-118 (AB01)" }, // Likely same as Dr. Manorma Chouhan F-102 (AB02)
  { name: "Ms. Rani Kumari", cabin: "A-247 (AB01)" },
  { name: "Ms. Ravina Toppo", cabin: "3rd Floor Ext. Cabin" },
  { name: "N. Vignesh", cabin: "A-209 (AB01)" },
  { name: "Nilam Venkatakoteswararao", cabin: "B-302 (AB01)" },
  { name: "Nitisha Pandey & Disha Kunda", cabin: "C-508 (AB01)" },
  { name: "P. Narendra Babu", cabin: "AB-410 (AB01)" },
  { name: "P. Vayunandanakishore", cabin: "A-526 (AB01)" },
  { name: "Prasad Begde", cabin: "C-540 (AB01)" },
  { name: "Pushpdant Jain", cabin: "A-412 (AB01)" },
  { name: "Rahul Kumar Chaturvedi", cabin: "A-234 (AB01)" },
  { name: "Rajendra Mahanandia", cabin: "N/A" },
  { name: "Rajneesh Kumar Patel", cabin: "A-306 (AB01)" }, // Likely same as Dr. Rajneesh Kumar Patel FC407 (AB02)
  { name: "Rohit Sharma", cabin: "A-320 (AB01)" },
  { name: "Satyam Ravi", cabin: "C-536 (AB01)" },
  { name: "Saurabh Bhargava", cabin: "B-401 (AB01)" },
  { name: "Saurav Prasad", cabin: "C-506 (AB01)" },
  { name: "SDC Team", cabin: "AB-311 (AB01)" },
  { name: "Sheerin Kayenat", cabin: "B-303 (AB01)" },
  { name: "Shilpa Suman", cabin: "C-538 (AB01)" },
  { name: "Shivmanjree Gopaliya", cabin: "A-307 (AB01)" },
  { name: "Shrrshthika Raikwal", cabin: "A-405 (AB01)" },
  { name: "Snskrithi Mishra & Pawan", cabin: "A-510 (AB01)" },
  { name: "Suchismita Patra", cabin: "A-233 (AB01)" },
  { name: "Sumit Mittal", cabin: "B-304 (AB01)" },
  { name: "Swati Chauhan", cabin: "A-236 (AB01)" },
  { name: "T Venkateswarao", cabin: "A-305 (AB01)" },
  { name: "Udai Kumar", cabin: "C-537 (AB01)" },
  { name: "Ujjwal Kumar Mishra", cabin: "A-220 (AB01)" },
  { name: "Usama Khan", cabin: "B-509 (AB01)" },
  { name: "Vijay Kumar Patel", cabin: "A-232 (AB01)" },
  { name: "Vijendra Singh Bramhe", cabin: "C-505 (AB01)" }, // Likely same as Dr. Vijendra Singh Bramhe FC410 (AB02)
];

